// @flow

import React from 'react'
import css from './Image.css'
import zoomOutIcon from '../../../assets/img/zoom-out.svg'

type Props = {
  img: string,
  closeImage: Function
}

const Image = (props: Props) => {
  const {img, closeImage} = props

  return (
    <div className={css.component} onClick={closeImage}>
      <div className={css.image}>
        <img
          className={css.zoomIcon}
          src={zoomOutIcon}
          alt=""
          onClick={closeImage}
        />
      </div>
      <img src={img} alt="" />
    </div>
  )
}

export default Image



// WEBPACK FOOTER //
// ./src/homepage/components/Image.js